import { NumberFixed } from '@delmonicos/shared-design-system-react/src/components/number-fixed/number-fixed';
import { Stack } from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import { TransactionModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/charge-hub-service-lib/src/wrapper/outputs/transaction/paginated/transaction.model';
import { CellContext } from '@tanstack/react-table';

export interface TransactionListKwhCellProps
  extends CellContext<TransactionModel, TransactionModel['kwh']> {}

export const TransactionListKwhCell = (
  props: TransactionListKwhCellProps,
): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { getValue } = props;

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <Stack justifyContent="flex-end">
      <NumberFixed number={getValue()} />
    </Stack>
  );
};
